<template>
  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="margin-bottom: 15px; font-weight: 600; border-bottom: 1px solid">
      {{ "SOC-" + code.toString().padStart(7, "0") }} - Datos Generales
    </h2>

    <div class="d-flex flex-wrap ga-3">
      <div class="w-in">
        <label><b></b>Tipo Solicitud:</label>

        <v-combobox
          pa-1
          ma-0
          hide-details
          v-model="tipoSol"
          :items="lstTipoSolicitud"
          variant="solo"
          item-title="id"
          item-value="Nombre"
        >
          <template slot="item" slot-scope="data">
            <div>
              <p class="font-weight-bold">{{ data.item.Nombre }}</p>
            </div>
          </template>
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Fecha Solicitud:</label>

        <v-text-field
          pa-1
          ma-0
          hide-details
          v-model="date"
          type="date"
          variant="solo"
          color="primary"
          disabled
          required
        />
      </div>

      <div class="w-in">
        <label>Ingresado Por:</label>

        <v-text-field
          variant="solo"
          pa-1
          ma-0
          v-model="solPorId"
          readonly
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label> Rut Ingresado Por: </label>
        <v-text-field
          variant="solo"
          pa-1
          ma-0
          v-model="solPorNombre"
          readonly
          hide-details
        >
        </v-text-field>
      </div>

      <div class="w-in">
        <label>Empresa:</label>

        <v-combobox
          v-model="empresaSel"
          pa-1
          hide-details
          ma-0
          :items="lstEmpresas"
          variant="solo"
          item-title="displayName"
          item-value="id"
          @update:search="selectCompany"
          clearable
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.displayName }}</div>
          </template>
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Departamento:</label>

        <v-combobox
          v-model="departamentoSel"
          pa-1
          ma-0
          hide-details
          :items="lstDepartamento"
          variant="solo"
          item-title="codeDisplayName"
          item-value="id"
          clearable
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Solicitante:</label>

        <v-combobox
          v-model="solicitanteSel"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          hide-details
          ma-0
          item-title="rutDisplayName"
          item-value="personId"
          clearable
          return-object
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.rutDisplayName }}</div>
          </template>
        </v-combobox>
      </div>

      <div class="w-in" v-if="tipoSol.id != 'Rendicion'">
        <label>Proyectos:</label>

        <v-combobox
          v-model="proyectoSel"
          pa-1
          hide-details
          ma-0
          :items="lstProyectos"
          variant="solo"
          item-title="codeDisplayName"
          item-value="id"
          clearable
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </div>

      <div class="w-in" v-if="tipoSol.id != 'Rendicion'">
        <label>Cod. Bod:</label>

        <v-combobox
          variant="solo"
          :items="lstBodegas"
          hide-details
          pa-1
          ma-0
          clearable
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="codBodega"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Observación:</label>

        <v-textarea variant="solo" pa-1 ma-0 v-model="obs" hide-details>
        </v-textarea>
      </div>

      <div v-if="adjuntos.length > 0" class="w-100">
        <label>{{ adjuntos.length }} Archivos Adjuntos:</label>

        <div class="text-center d-flex flex-wrap">
          <div
            v-for="(adj, index) in adjuntos"
            :key="index"
            style="align-items: center"
          >
            <v-tooltip :text="adj.nombre">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  class="ma-2"
                  style="
                    height: 55px;
                    background-color: #a61a2f;
                    color: white;
                    border-radius: 11px;
                  "
                  @click="bajarAdjunto(sliceString(adj.url))"
                >
                  <v-icon size="x-large">{{ setIcon(adj.nombre) }}</v-icon>
                  <div>Archivo {{ index + 1 }}</div>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>

    <h2 style="font-weight: 600; margin-top: 10px">Detalle Solicitud</h2>

    <div class="w-in">
      <v-combobox
        style="font-size: 16px"
        pa-1
        ma-0
        ref="mySearch"
        :loading="loading"
        :items="lstItems"
        :hide-no-data="false"
        v-model="item"
        item-title="numberDisplayName"
        item-value="id"
        variant="solo"
        dense
        label="Busca un Material/Servicio"
        no-data-text="No se encontro Material/Servicio"
        @update:search="BuscarMaterial"
        return-object
      >
        <template slot="item" slot-scope="data">
          <div>{{ data.item.numberDisplayName }}</div>
        </template>
      </v-combobox>
    </div>

    <!--<v-data-table
      v-if="
        tipoSol != null &&
        (tipoSol.id == 'Retiro Bodega' || tipoSol.id == 'Compra')
      "
      :headers="headers"
      :items="lstDetalle"
    >
      <template v-slot:item.Cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          v-model="item.Cantidad"
          @update:modelValue="CalcularTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.Precio="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          v-model="item.Precio"
          @update:modelValue="CalcularTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.Total="{ item }">
        {{ formatMoney(item.Total) }}
      </template>

      <template v-slot:item.CecoId="{ item }">
        <v-combobox
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.CecoId"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </template>

      <template v-slot:item.CodigoBodega="{ item }">
        <v-combobox
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.CodigoBodega"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>-->

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Compra'"
      :headers="headers"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          v-model="item.cantidad"
          @update:modelValue="CalcularTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.precio="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          v-model="item.precio"
          @update:modelValue="CalcularTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.total="{ item }">
        {{ formatMoney(item.total) }}
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-combobox
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </template>

      <template v-slot:item.codigoBodega="{ item }">
        <v-combobox
          variant="outlined"
          :items="lstBodegas"
          density="compact"
          hide-details
          pa-1
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.codigoBodega"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol != null && tipoSol.id == 'Retiro Bodega'"
      :headers="headersRetiro"
      :items="lstDetalle"
    >
      <template v-slot:item.cantidad="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          v-model="item.cantidad"
          @update:modelValue="CalcularTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-combobox
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-combobox>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <v-data-table
      v-if="tipoSol.id === 'Rendicion'"
      :headers="headersRendicion"
      :items="lstDetalle"
    >
      <template v-slot:item.tipoDoc="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstTipoDoc"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="Nombre"
          item-value="id"
          :return-object="false"
          v-model="item.tipoDoc"
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.Nombre }}</div>
          </template>
        </v-autocomplete>
      </template>

      <template v-slot:item.nroDoc="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.nroDoc"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.fechaDoc="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.fechaDoc"
          type="date"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.Material="{ item }">
        {{ item.Material }}
      </template>

      <template v-slot:item.proveedorId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstVendors"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="numberDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.proveedorId"
          clearable
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.displayName }}</div>
          </template>
        </v-autocomplete>
      </template>

      <template v-slot:item.descGasto="{ item }">
        <v-text-field
          pa-1
          ma-0
          v-model="item.descGasto"
          variant="outlined"
          color="primary"
          required
          density="compact"
          hide-details
        />
      </template>

      <template v-slot:item.monto="{ item }">
        <v-text-field
          variant="outlined"
          density="compact"
          hide-details
          pa-1
          ma-0
          v-model="item.monto"
          @update:modelValue="RendicionTotal(item)"
        >
        </v-text-field>
      </template>

      <template v-slot:item.cecoId="{ item }">
        <v-autocomplete
          variant="outlined"
          :items="lstCeco"
          density="compact"
          pa-1
          ma-0
          hide-details
          item-title="codeDisplayName"
          item-value="id"
          :return-object="false"
          v-model="item.cecoId"
          clearable
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-autocomplete>
      </template>

      <template v-slot:item.proyectoId="{ item }">
        <v-autocomplete
          v-model="item.proyectoId"
          pa-1
          ma-0
          :items="lstProyectos"
          variant="outlined"
          item-title="codeDisplayName"
          item-value="id"
          density="compact"
          clearable
          :return-object="false"
          hide-details
        >
          <template slot="item" slot-scope="data">
            <div>{{ data.item.codeDisplayName }}</div>
          </template>
        </v-autocomplete>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon icon="mdi-delete" color="red" @click="showDeleteDialog(item)" />
      </template>
    </v-data-table>

    <div
      v-if="tipoSol.id == 'Rendicion'"
      style="
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 5px;
        display: flex;
        justify-content: flex-end;
      "
    >
      Total: {{ formatMoney(total) }}
    </div>

    <div class="d-flex flex-wrap">
      <div class="w-in">
        <v-file-input
          pa-1
          ma-0
          v-model="selectedFiles"
          multiple
          label="Selecciona archivos"
          variant="solo"
          @update:modelValue="addFiles"
        >
        </v-file-input>

        <v-chip closable v-for="f in file">
          {{ f.name }}
        </v-chip>
      </div>
      <div class="w-69 d-flex mt-3" style="justify-content: end">
        <v-btn
          style="
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            color: white;
            margin-right: 5px;
            display: flex;
          "
          density="default"
          v-on:click="guardarSolicitud()"
          >Guardar</v-btn
        >

        <v-btn
          style="
            background-color: #10510e;
            padding: 15px;
            border-radius: 15px;
            color: white;
            display: flex;
          "
          density="default"
          v-on:click="crearSolicitud()"
          >Crear Solicitud</v-btn
        >
      </div>
    </div>
  </div>
  <v-dialog v-model="dialogDelete" persistent width="auto">
    <v-card>
      <v-card-title class="text-h5"> Borrar Item </v-card-title>
      <v-card-text>
        Esta seguro que desea item el material `{{
          itemToDelete.CodigoMaterial
        }}` ?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialogDelete = false">No</v-btn>
        <v-btn color="primary" text @click="deleteMaterial(itemToDelete)"
          >Si</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <loading v-model:active="isLoading" :is-full-page="fullPage" />
</template>

<script>
import store from "../store/index.js";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import { PublicClientApplication } from "@azure/msal-browser";
import AzureService from "@/services/AzureService";

export default {
  name: "app",
  components: {
    Loading,
  },
  data() {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      solPorId: "",
      solPorNombre: "",

      solicitantePor: null,

      lstEmpresas: [],
      empresaSel: null,
      lstDepartamento: [],
      departamentoSel: null,

      lstSolicitantes: [],
      solicitanteSel: null,

      solId: "",
      solNombre: "",
      obs: "",

      lstDetalle: [],
      headers: [
        { title: "Id", key: "id", width: "25px" },
        { title: "Tipo", key: "tipo", align: "start" },
        {
          title: "Cod",
          key: "codigoMaterial",
          align: "center",
          width: "120px",
        },
        { title: "Material/Servicio", key: "material", align: "start" },
        { title: "UN", key: "unidad", align: "center" },
        { title: "Q", key: "cantidad", align: "center", width: "100px" },
        { title: "Precio", key: "precio", align: "center", width: "150px" },
        { title: "Total", key: "total", align: "center" },
        { title: "Ceco", key: "cecoId", align: "start", width: "250px" },
        {
          title: "Cod. Bod.",
          key: "codigoBodega",
          align: "center",
          width: "350px",
        },
        { title: "", key: "actions", align: "center", width: "25px" },
      ],

      headersRetiro: [
        { title: "Id", key: "id", width: "25px" },
        { title: "Tipo", key: "tipo", align: "start", width: "100px" },
        {
          title: "Cod",
          key: "codigoMaterial",
          align: "center",
          width: "120px",
        },
        {
          title: "Material/Servicio",
          key: "material",
          align: "start",
          width: "150px",
        },
        { title: "UN", key: "unidad", align: "center", width: "50px" },
        { title: "Q", key: "cantidad", align: "center", width: "100px" },
        // { title: "Precio", key: "precio", align: "center", width: "150px" },
        // { title: "Total", key: "total", align: "center" },
        { title: "Ceco", key: "cecoId", align: "start", width: "250px" },
        // {
        //   title: "Cod. Bod.",
        //   key: "codigoBodega",
        //   align: "center",
        //   width: "350px",
        // },
        { title: "", key: "actions", align: "center", width: "25px" },
      ],

      headersRendicion: [
        { title: "Id", key: "id", width: "25px" },
        {
          title: "Tipo Docto",
          key: "tipoDoc",
          align: "center",
          width: "220px",
        },
        { title: "N° Docto", key: "nroDoc", align: "center", width: "100px" },
        {
          title: "Fecha Docto",
          key: "fechaDoc",
          align: "center",
          width: "200px",
        },
        {
          title: "Proveedor",
          key: "proveedorId",
          align: "center",
          width: "200px",
        },
        {
          title: "Material/Servicio",
          key: "material",
          align: "center",
          width: "150px",
        },
        {
          title: "Descripción del Gasto",
          key: "descGasto",
          align: "center",
          width: "150px",
        },
        { title: "Ceco", key: "cecoId", align: "center", width: "250px" },
        //{ title: "Depto", key: "DeptoId", align: "center", width: "250px" },
        {
          title: "Proyecto",
          key: "proyectoId",
          align: "center",
          width: "250px",
        },
        { title: "Monto", key: "monto", align: "center", width: "150px" },
        { title: "", key: "actions", align: "center", width: "25px" },
      ],

      lstCeco: [],
      cecoSel: null,

      loading: false,
      lstItems: [],
      item: null,
      guid: "",
      file: [],
      selectedFiles: [],
      fileName: "",

      lstBodegas: [],
      bodegaSel: null,
      detContador: 1,
      dialogDelete: false,

      isLoading: false,
      fullPage: true,
      account: {},

      lstVendors: [],
      vendorSel: null,
      lstTipoSolicitud: [
        { id: "Compra", Nombre: "Compra" },
        { id: "Retiro Bodega", Nombre: "Retiro Bodega" },
        { id: "Rendicion", Nombre: "Rendición" },
      ],

      lstProyectos: [],
      proyectoSel: null,
      tipoSol: { id: "Compra", Nombre: "Compra" },
      //tipoSol: { id: "Rendicion", Nombre: "Rendicion" },

      lstTipoDoc: [
        { id: "Sin Documento", Nombre: "Sin Documento" },
        { id: "Boleta", Nombre: "Boleta" },
        { id: "Factura", Nombre: "Factura" },
        { id: "Vale", Nombre: "Vale" },
        { id: "B. Honorarios", Nombre: "B. Honorarios" },
      ],

      total: 0,
      adjuntos: [],
      code: 0,
      codBodega: null,
    };
  },

  methods: {
    BuscarMaterial: async function () {
      if (typeof this.item === "string" || this.item instanceof String) {
        this.loading = true;
        if (this.item != "" && this.item.length > 2) {
          if (this.empresaSel == null) {
            this.loading = false;
            this.item = null;

            this.$swal.fire({
              icon: "warning",
              title: "Debe seleccionar una empresa",
              showConfirmButton: true,
            });
            return;
          }

          axios
            .get(
              store.state.url +
                "api/Item/BuscadorItem?item=" +
                this.item +
                "&companyId=" +
                this.empresaSel.id,
              {
                headers: {},
              }
            )
            .then((response) => {
              if (response.status == 200) {
                this.lstItems = response.data;
                this.loading = false;
              } else {
                console.log(response.statusText);
              }
            })
            .catch(function (error) {
              console.log(error.message);
            })
            .finally(() => (this.loading = false));
        }
      } else {
        if (this.item != null) {
          let det = {};

          if (this.tipoSol.id == "Rendicion") {
            det = {
              idItem: this.item.id,
              id: this.detContador,
              encabezadoId: this.idSolicitud,
              codigoMaterial: this.item.number,
              material: this.item.displayName,
              retiroBodega: false,
              monto: 0,
            };
          } else {
            det = {
              idItem: this.item.id,
              id: this.detContador,
              tipo: this.item.itemCategoryCode,
              encabezadoId: this.idSolicitud,
              codigoMaterial: this.item.number,
              material: this.item.displayName,
              unidad: "UN",
              cantidad: 0,
              precio: 0,
              total: 0,
            };

            if (this.tipoSol.id == "Retiro Bodega") {
              det.RetiroBodega = true;
            } else {
              det.RetiroBodega = false;
            }

            if (this.item.type == "Service") {
              det.Cantidad = 1;
            }
          }

          this.lstDetalle.push(det);

          this.item = null;
          this.detContador++;
        }
      }
    },

    getDepartamentos: async function () {
      try {
        //console.log(this.empresaSel);

        await axios
          .get(
            store.state.url +
              "api/Departamento/GetDepartamentos?company=" +
              this.empresaSel.id,
            {
              headers: {},
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.lstDepartamento = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getCompanies: function () {
      try {
        axios
          .get(store.state.url + "api/Company/GetCompanies", { headers: {} })
          .then(async (response) => {
            if (response.status == 200) {
              this.lstEmpresas = response.data;

              this.isLoading = true;
              this.getSolicitudCompra();
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getCeco: async function () {
      try {
        await axios
          .get(
            store.state.url + "api/Ceco/GetCecos?company=" + this.empresaSel.id,
            { headers: {} }
          )
          .then((response) => {
            if (response.status == 200) {
              this.lstCeco = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getBodegas: async function () {
      try {
        await axios
          .get(
            store.state.url +
              "api/Location/GetLocations?company=" +
              this.empresaSel.id,
            { headers: {} }
          )
          .then((response) => {
            if (response.status == 200) {
              this.lstBodegas = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getVendors: async function () {
      try {
        await axios
          .get(
            store.state.url +
              "api/Vendors/GetVendors?company=" +
              this.empresaSel.id,
            { headers: {} }
          )
          .then((response) => {
            if (response.status == 200) {
              this.lstVendors = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getProyectos: async function () {
      try {
        await axios
          .get(
            store.state.url +
              "api/Proyecto/GetProyectos?company=" +
              this.empresaSel.id,
            { headers: {} }
          )
          .then((response) => {
            if (response.status == 200) {
              this.lstProyectos = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getSolicitantes: async function () {
      try {
        await axios
          .get(store.state.url + "api/Empleado/GetEmpleados", { headers: {} })
          .then((response) => {
            if (response.status == 200) {
              this.lstSolicitantes = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      }
    },

    getSolicitudCompra: function () {
      try {
        axios
          .get(
            store.state.url +
              "api/SolicitudCompra/GetSolicitudCompra?solicitudId=" +
              this.$route.params.solicitudId
          )
          .then(async (response) => {
            if (response.status == 200) {
              var solicitud = response.data;

              this.idSolicitud = solicitud.encabezado.id;
              this.tipoSol.id = solicitud.encabezado.tipoSolicitudId;
              this.date = solicitud.encabezado.fechaSolicitud.substr(0, 10);
              this.solPorId = solicitud.encabezado.solicitantePorId;
              this.solPorNombre = solicitud.encabezado.solicitantePorNombre;
              this.solId = solicitud.encabezado.solicitanteId;
              this.solNombre = solicitud.encabezado.solicitanteNombre;
              this.code = solicitud.encabezado.code;

              if (solicitud.encabezado.companyId != null) {
                this.empresaSel = this.lstEmpresas.find(
                  (r) => r.id == solicitud.encabezado.companyId
                );
              }

              if (this.empresaSel != null) {
                await this.getDepartamentos();
                await this.getCeco();
                await this.getBodegas();
                await this.getVendors();
                await this.getProyectos();
              }

              await this.getSolicitantes();

              if (this.$cookies.get("username") != "") {
                this.obtenerEmpleado(this.$cookies.get("username"));
                // this.obtenerEmpleado("abuchholz@oxxeanchile.cl");
              }

              if (solicitud.encabezado.departamentoId != null) {
                this.departamentoSel = this.lstDepartamento.find(
                  (d) => d.id == solicitud.encabezado.departamentoId
                );
              }

              this.solicitanteSel = this.lstSolicitantes.find(
                (s) => s.rut == solicitud.encabezado.solicitanteId
              );

              this.obs = solicitud.encabezado.observacion;
              this.adjuntos = await this.getFiles();

              this.vendorSel = this.lstVendors.find(
                (v) => v.id == solicitud.encabezado.vendorId
              );
              this.estado = solicitud.encabezado.estado;
              this.tipo = solicitud.encabezado.tipoSolicitudId;

              if (this.tipo == "Retiro Bodega") {
                this.codigoDes = solicitud.encabezado.codigoDespacho;
                this.codBodega = this.lstBodegas.find(
                  (b) => b.id == solicitud.encabezado.codigoBodega
                );
              }

              if (this.tipo == "Compra") {
                this.idBc365 = solicitud.encabezado.bC365Id;
                this.codBodega = this.lstBodegas.find(
                  (b) => b.id == solicitud.encabezado.codigoBodega
                );
              }

              if (solicitud.encabezado.proyectoId != null) {
                this.proyectoSel = this.lstProyectos.find(
                  (p) => p.id == solicitud.encabezado.proyectoId
                );
              }

              if (this.tipoSol.id == "Rendicion") {
                for (let i = 0; i < solicitud.detalle.length; i++) {
                  /*                   solicitud.detalle[i].cecoId = this.lstCeco.find(
                    (c) => c.id == solicitud.detalle[i].cecoId
                  ); */

                  if (solicitud.detalle[i].fechaDoc != null) {
                    solicitud.detalle[i].fechaDoc = solicitud.detalle[
                      i
                    ].fechaDoc.substr(0, 10);
                  }

                  if (this.empresaSel == null) {
                    solicitud.detalle[i].cecoId = null;
                    solicitud.detalle[i].proyectoId = null;
                  }
                }
              }

              this.lstDetalle = solicitud.detalle;
              this.detContador = this.lstDetalle.length + 1;

              // console.log(JSON.stringify(this.lstDetalle));

              this.RendicionTotal();
            }
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => (this.isLoading = false));
      } catch (error) {
        console.log(error);
      }
    },

    obtenerEmpleado: function (email) {
      try {
        //this.isLoading = true;

        axios
          .get(
            store.state.url + "api/Empleado/GetEmpleadoXEmail?email=" + email,
            { headers: {} }
          )
          .then((response) => {
            if (response.status == 200) {
              this.solicitantePor = response.data;

              this.solPorId = this.solicitantePor.rut;
              this.solPorNombre = this.solicitantePor.fullName;
            } else {
              this.solPorId = "";
              this.solPorNombre = "";
              //console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });
      } catch (error) {
        console.log(error);
      } /* finally {
        this.isLoading = false;
      } */
    },

    guardarSolicitud: async function () {
      try {
        var encab = {};
        var detalle = [];

        if (
          this.solPorId == null ||
          this.solPorId == "" ||
          this.solPorNombre == null ||
          this.solPorNombre == ""
        ) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe haber un ingresado por",
            showConfirmButton: true,
          });
          return;
        }

        this.isLoading = true;

        if (this.tipoSol.id == "Compra" || this.tipoSol.id == "Retiro Bodega") {
          encab = {
            Id: this.idSolicitud,
            FechaSolicitud: this.date,
            SolicitantePorId: this.solPorId,
            SolicitantePorNombre: this.solPorNombre,
            CompanyId: this.empresaSel != null ? this.empresaSel.id : null,
            DepartamentoId:
              this.departamentoSel != null ? this.departamentoSel.id : null,

            Observacion: this.obs,

            SolicitanteId:
              this.solicitanteSel != null ? this.solicitanteSel.rut : null,

            SolicitanteNombre:
              this.solicitanteSel != null ? this.solicitanteSel.fullName : null,

            VendorId: this.vendorSel != null ? this.vendorSel.id : null,
            Estado: "Guardada",
            TipoSolicitudId: this.tipoSol.id,
            ProyectoId: this.proyectoSel != null ? this.proyectoSel.id : null,
          };

          if (
            typeof this.codBodega === "string" ||
            this.codBodega instanceof String
          ) {
            encab.CodigoBodega = this.codBodega != null ? this.codBodega : null;
          } else {
            encab.CodigoBodega =
              this.codBodega != null ? this.codBodega.id : null;
          }

          detalle = this.lstDetalle;

          let solicitud = {
            Encabezado: encab,
            Detalle: detalle,
          };

          // console.log(JSON.stringify(solicitud));
          this.enviarSolicitudGuardada(solicitud);
          //}
        } else {
          if (this.tipoSol.id == "Rendicion") {
            encab = {
              Id: this.idSolicitud,
              FechaSolicitud: this.date,
              SolicitantePorId: this.solPorId,
              SolicitantePorNombre: this.solPorNombre,
              CompanyId: this.empresaSel != null ? this.empresaSel.id : null,
              DepartamentoId:
                this.departamentoSel != null ? this.departamentoSel.id : null,
              Observacion: this.obs,
              SolicitanteId:
                this.solicitanteSel != null ? this.solicitanteSel.rut : null,
              SolicitanteNombre:
                this.solicitanteSel != null
                  ? this.solicitanteSel.fullName
                  : null,
              Estado: "Guardada",
              TipoSolicitudId: this.tipoSol.id,
              ProyectoId: this.proyectoSel != null ? this.proyectoSel.id : null,
            };

            detalle = this.lstDetalle;

            if (this.departamentoSel != null) {
              for (let i = 0; i < detalle.length; i++) {
                detalle[i].DeptoId = this.departamentoSel.id;
              }
            }

            let solicitud = {
              Encabezado: encab,
              Detalle: detalle,
            };

            //console.log(JSON.stringify(solicitud));
            this.enviarSolicitudGuardada(solicitud);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    enviarSolicitudGuardada: async function (solicitud) {
      this.isLoading = true;

      axios
        .post(
          store.state.url + "api/SolicitudCompra/PostSolicitudCompraGuardada",
          solicitud
        )
        .then(async (response) => {
          if (response.status == 200) {
            if (this.file.length > 0) {
              await this.submitFile(solicitud, "guardar");
            }

            this.date = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);

            this.$swal.fire({
              icon: "success",
              title: "Solicitud Guardada Exitosamente",
              showConfirmButton: false,
              timer: 2000,
            });

            this.$router.push({
              name: "BuscaSolicitud",
            });
          } else {
            console.log(response.statusText);
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
        })
        .finally(() => (this.isLoading = false));
    },

    crearSolicitud: async function () {
      try {
        if (this.tipoSol == null) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe seleccionar un tipo de solicitud",
            showConfirmButton: true,
          });
          return;
        }

        if (this.empresaSel == null) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe seleccionar una empresa",
            showConfirmButton: true,
          });
          return;
        }

        if (this.departamentoSel == null) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe seleccionar un departamento",
            showConfirmButton: true,
          });
          return;
        }

        if (this.solicitanteSel == null) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe seleccionar un Solicitante",
            showConfirmButton: true,
          });
          return;
        }

        // if (this.codBodega == null) {
        //   this.$swal.fire({
        //     icon: "warning",
        //     title: "Debe seleccionar una bodega",
        //     showConfirmButton: true,
        //   });
        //   return;
        // }

        if (this.lstDetalle.length == 0) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe agregar al menos un material",
            showConfirmButton: true,
          });
          return;
        }

        if (this.lstDetalle.some((x) => x.cecoId == null)) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe seleccionar un ceco",
            showConfirmButton: true,
          });
          return;
        }

        if (
          this.solPorId == null ||
          this.solPorId == "" ||
          this.solPorNombre == null ||
          this.solPorNombre == ""
        ) {
          this.$swal.fire({
            icon: "warning",
            title: "Debe haber un ingresado por",
            showConfirmButton: true,
          });
          return;
        }

        var encab = {};
        var detalle = [];

        this.isLoading = true;

        if (this.tipoSol.id == "Compra" || this.tipoSol.id == "Retiro Bodega") {
          if (this.lstDetalle.some((x) => x.Cantidad == 0)) {
            this.$swal.fire({
              icon: "warning",
              title: "Debe ingresar una cantidad mayor a 0",
              showConfirmButton: true,
            });
            return;
          }

          // if (this.lstDetalle.some((x) => x.codigoBodega == null)) {
          //   this.$swal.fire({
          //     icon: "warning",
          //     title: "Debe seleccionar una bodega",
          //     showConfirmButton: true,
          //   });
          //   return;
          // }

          if (this.tipoSol.id == "Retiro Bodega") {
            if (this.codBodega == null) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe seleccionar una bodega",
                showConfirmButton: true,
              });
              return;
            }
          }

          encab = {
            Id: this.idSolicitud,
            FechaSolicitud: this.date,
            SolicitantePorId: this.solPorId,
            SolicitantePorNombre: this.solPorNombre,
            CompanyId: this.empresaSel.id,
            DepartamentoId: this.departamentoSel.id,
            Observacion: this.obs,
            SolicitanteId: this.solicitanteSel.rut,
            SolicitanteNombre: this.solicitanteSel.fullName,
            VendorId: this.vendorSel != null ? this.vendorSel.id : null,
            Estado: "Creada",
            TipoSolicitudId: this.tipoSol.id,
            ProyectoId: this.proyectoSel != null ? this.proyectoSel.id : null,
          };

          if (
            typeof this.codBodega === "string" ||
            this.codBodega instanceof String
          ) {
            encab.CodigoBodega = this.codBodega != null ? this.codBodega : null;
          } else {
            encab.CodigoBodega =
              this.codBodega != null ? this.codBodega.id : null;
          }

          detalle = this.lstDetalle;

          let solicitud = {
            Encabezado: encab,
            Detalle: detalle,
          };

          // console.log(JSON.stringify(solicitud));
          this.enviarSolicitud(solicitud);
        } else {
          if (this.tipoSol.id == "Rendicion") {
            if (this.lstDetalle.some((x) => x.tipoDoc == null)) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe seleccionar un tipo de documento",
                showConfirmButton: true,
              });
              return;
            }

            if (this.lstDetalle.some((x) => x.fechaDoc == null)) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe seleccionar una fecha de documento",
                showConfirmButton: true,
              });
              return;
            }

            if (
              this.lstDetalle.some(
                (x) =>
                  x.nroDoc == null &&
                  x.tipoDoc != "Sin Documento" &&
                  x.tipoDoc != "Vale"
              )
            ) {
              this.loading = false;

              this.$swal.fire({
                icon: "warning",
                title: "Debe ingresar un numero de documento",
                showConfirmButton: true,
              });
              return;
            }

            if (
              this.lstDetalle.some(
                (x) => x.proveedorId == null && x.tipoDoc == "Factura"
              )
            ) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe seleccionar un proveedor",
                showConfirmButton: true,
              });
              return;
            }

            if (
              this.lstDetalle.some(
                (x) => x.proveedorId == null && x.tipoDoc == "B. Honorarios"
              )
            ) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe seleccionar un proveedor",
                showConfirmButton: true,
              });
              return;
            }

            if (this.lstDetalle.some((x) => x.descGasto == null)) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe ingresar una descripción del gasto",
                showConfirmButton: true,
              });
              return;
            }

            if (this.lstDetalle.some((x) => x.monto == null)) {
              this.$swal.fire({
                icon: "warning",
                title: "Debe ingresar un monto",
                showConfirmButton: true,
              });
              return;
            }

            encab = {
              Id: this.idSolicitud,
              FechaSolicitud: this.date,
              SolicitantePorId: this.solPorId,
              SolicitantePorNombre: this.solPorNombre,
              CompanyId: this.empresaSel.id,
              DepartamentoId: this.departamentoSel.id,
              Observacion: this.obs,
              SolicitanteId: this.solicitanteSel.rut, //this.solId,
              SolicitanteNombre: this.solicitanteSel.fullName, //this.solNombre,
              //VendorId: this.vendorSel != null ? this.vendorSel.id : null,
              Estado: "Creada",
              TipoSolicitudId: this.tipoSol.id, //"Compra",
              //ProyectoId: this.proyectoSel != null ? this.proyectoSel.id : null,
            };

            detalle = this.lstDetalle;

            for (let i = 0; i < detalle.length; i++) {
              detalle[i].DeptoId = this.departamentoSel.id;
            }

            /*             if (this.file.length > 0) {
              //this.file = this.$refs.file.files;

              let solicitud = {
                Encabezado: encab,
                Detalle: detalle,
              };

              await this.submitFile(solicitud, "crear");
            } else {
              encab.ArchivoAdjunto = null; */

            let solicitud = {
              Encabezado: encab,
              Detalle: detalle,
            };

            //console.log(JSON.stringify(solicitud));
            this.enviarSolicitud(solicitud);
            //}
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    enviarSolicitud: async function (solicitud) {
      axios
        .post(
          store.state.url + "api/SolicitudCompra/PostSolicitudCompra",
          solicitud
        )
        .then(async (response) => {
          if (response.status == 200) {
            if (this.file.length > 0) {
              await this.submitFile(solicitud, "crear");
            }

            this.date = new Date(
              Date.now() - new Date().getTimezoneOffset() * 60000
            )
              .toISOString()
              .substr(0, 10);

            this.empresaSel = null;
            this.departamentoSel = null;
            this.vendorSel = null;
            this.solicitanteSel = null;
            this.obs = "";

            this.lstItems = [];
            this.lstDetalle = [];
            this.file = {};

            this.detContador = 1;
            //this.guid = this.getGUID();

            this.$swal.fire({
              icon: "success",
              title: "Solicitud Creada Exitosamente",
              showConfirmButton: false,
              timer: 2000,
            });

            if (this.$cookies.get("username") != "") {
              this.obtenerEmpleado(this.$cookies.get("username"));
              // this.obtenerEmpleado("abuchholz@oxxeanchile.cl");
            }

            await this.sendEmail(solicitud.Encabezado.Id);

            this.$router.push({
              name: "BuscaSolicitud",
            });
          } else {
            console.log(response.statusText);
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
        })
        .finally(() => (this.isLoading = false));
    },

    getFiles: async function () {
      try {
        var archivos = [];

        await axios
          .get(
            store.state.url +
              "api/SolicitudCompra/GetSolicitudFiles?solicitudId=" +
              this.idSolicitud
          )
          .then((response) => {
            if (response.status == 200) {
              //console.log(response.data);
              archivos = response.data;
            } else {
              console.log(response.statusText);
            }
          })
          .catch(function (error) {
            console.log(error.message);
          });

        return archivos;
      } catch (error) {
        console.log(error);
      }
    },

    bajarAdjunto: function (filename) {
      try {
        this.isLoading = true;

        const link = document.createElement("a");
        link.href =
          store.state.url +
          "api/SolicitudCompra/DownloadFile?fileName=" +
          filename;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    setIcon: function (fileName) {
      try {
        var icon = "";

        var ext = fileName.substring(fileName.lastIndexOf(".") + 1);

        switch (ext) {
          case "pdf":
            icon = "mdi-file-pdf-box";
            break;

          case "docx" || "doc":
            icon = "mdi-file-word";
            break;

          case "xlsx" || "xls":
            icon = "mdi-file-excel";
            break;

          case "pptx" || "ppt":
            icon = "mdi-file-powerpoint";
            break;

          case "jpg" || "jpeg" || "png" || "gif":
            icon = "mdi-file-image";
            break;

          case "zip" || "rar" || "7z":
            icon = "mdi-zip-box";
            break;

          case "txt":
            icon = "mdi-file-document";
            break;

          default:
            icon = "mdi-file";
            break;
        }

        //console.log(icon);

        return icon;
      } catch (error) {
        console.log(error);
      }
    },

    RendicionTotal: function () {
      this.total = this.lstDetalle.reduce(
        (acc, item) => acc + parseFloat(item.monto),
        0
      );
    },

    sliceString(value) {
      return value.substring(value.lastIndexOf("/") + 1);
    },

    formatMoney: function (value) {
      return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
      }).format(value);
    },

    selectCompany: async function () {
      try {
        this.isLoading = true;
        if (typeof this.empresaSel != "string" && this.empresaSel != null) {
          //console.log(JSON.stringify(this.empresaSel));

          await this.getDepartamentos();
          await this.getVendors();
          await this.getProyectos();
          await this.getCeco();
          await this.getBodegas();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

    showDeleteDialog(item) {
      this.itemToDelete = item;
      this.dialogDelete = !this.dialogDelete;
    },

    deleteMaterial: function (item) {
      const index = this.lstDetalle.indexOf(item);
      this.lstDetalle.splice(index, 1);

      this.dialogDelete = !this.dialogDelete;

      for (let i = 0; i < this.lstDetalle.length; i++) {
        this.lstDetalle[i].id = i + 1;
      }

      this.detContador = this.lstDetalle.length + 1;
    },

    async submitFile(solicitud, tipo) {
      const files = new FormData();

      for (let i = 0; i < this.file.length; i++) {
        files.append("files", this.file[i]);
      }
      //files.append("files", this.file);
      const headers = { "Content-Type": "multipart/form-data" };
      axios
        .post(
          store.state.url + "api/SolicitudCompra/UploadMultipleFile",
          files,
          {
            headers,
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.postFiles(res.data, solicitud.Encabezado.Id);
            console.log(tipo);
            /*             if (tipo == "guardar") {
              this.enviarSolicitudGuardada(solicitud);
            } else {
              this.enviarSolicitud(solicitud);
            } */
          } else {
            console.log("Error al cargar archivo, status code:" + res.status);
          }
        })
        .finally(() => (this.isLoading = false));
    },

    postFiles: function (files, solId) {
      axios
        .post(
          store.state.url +
            "api/SolicitudCompra/PostFiles?solicitudId=" +
            solId,
          files,
          { headers: {} }
        )
        .then((response) => {
          if (response.status == 200) {
            console.log("Archivos subidos correctamente");
          } else {
            console.log(response.statusText);
          }
        })
        .catch(function (error) {
          console.log(error.message);
        });
    },

    addFiles: async function () {
      for (var f of this.selectedFiles) {
        this.file.push(f);
      }

      this.selectedFiles = [];
    },

    sendEmail: async function (idSol) {
      try {
        await this.refreshToken()
          .then(async () => {
            var token = this.$cookies.get("token");

            await axios
              .post(
                store.state.url +
                  "api/SolicitudCompra/SendEmail?idSol=" +
                  idSol,
                token,
                { headers: { "Content-Type": "application/json" } }
              )
              .then((response) => {
                if (response.status == 200) {
                  console.log(response.data);
                } else {
                  console.log(response.statusText);
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },

    CalcularTotal: function (item) {
      item.total = item.cantidad * item.precio;
    },

    refreshToken: async function () {
      try {
        await this.$msalInstance.initialize();
        //await this.$msalInstance.handleRedirectPromise();

        var redirectResponse = await this.$msalInstance.handleRedirectPromise();
        if (redirectResponse !== null) {
          //console.log(redirectResponse.accessToken);
          this.$cookies.set("token", redirectResponse.accessToken);
        } else {
          var myAcccount = this.$msalInstance.getAllAccounts();

          await this.$msalInstance
            .acquireTokenSilent({
              scopes: ["User.Read", "Mail.Send"],
              account: myAcccount[0],
            })
            .then((response) => {
              this.$cookies.set("token", response.accessToken);
              //console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      } catch (error) {
        console.log(error);
      }
    },
  },

  async created() {
    const azureService = new AzureService();

    this.$msalInstance = new PublicClientApplication(
      azureService.getMsalConfig().value
    );

    store.state.titulo = "Editar Solicitud";

    await this.getCompanies();
  },
};
</script>
